class TitleScroll {
    constructor(parent, data) {
        window.addEventListener('scroll', () => {
            this.checkNavbarDistance();
        });
        window.addEventListener('resize', () => {
            this.checkNavbarDistance();
        });
        this.checkNavbarDistance();
    }

    checkNavbarDistance() {
        const title = document.querySelector('[data-title-scroll]');
        if (null === title) {
            return;
        }

        const titleHeight = title.getBoundingClientRect().height;
        const navbar = document.querySelector('[data-title-scroll-anchor]');
        const targets = document.querySelectorAll('[data-title-scroll-target]');

        const navbarRect = navbar.getBoundingClientRect();

        let transform = 'translate3d(0,0,0)';
        targets.forEach((footer, idx) => {
            const footerRect = footer.getBoundingClientRect();

            const halfViewportHeight = 140;
            const distance = footerRect.top - navbarRect.bottom;

            if (distance < halfViewportHeight) {
                transform = `translate3d(0,${-(idx * titleHeight)}px,0)`;
            }
        });

        if (0 === title.children.length) {
            return;
        }

        title.children[0].style.transform = transform;
    }
}

export default TitleScroll